import React from 'react'
import { components, constants } from 'cng-web-lib'
import CollapsibleSection from '../../../../components/ui/CollapsibleSection'
import EPA35201FormFormProperties from './EPA35201FormFormProperties'
import { useFormContext } from 'react-hook-form'
import _ from 'lodash'
import { Grid } from '@material-ui/core'

const {
  button: { CngButton },
  form: { CngForm }
} = components

const { FormState } = constants

const { initialValues, makeValidationSchema } =
  EPA35201FormFormProperties.formikProps

function EPA35201FormSection(props) {
  const { onSetDeclaration, title } = props

  const { watch } = useFormContext()
  const EPA35201Form = watch('nbciusinvoiceDetailsEPA35201Form')

  return (
    <CollapsibleSection defaultExpanded={!_.isEmpty(EPA35201Form)} title={title}>
      {_.isEmpty(EPA35201Form) ? (
        <CngForm
          formikProps={{
            initialValues,
            makeValidationSchema,
            onSubmit: (data) =>
              onSetDeclaration('nbciusinvoiceDetailsEPA35201Form', [data])
          }}
          formState={FormState.COMPLETED}
          innerForm
          renderBodySection={(labelMap, shouldHideMap) => (
            <EPA35201FormFormProperties.Fields shouldHideMap={shouldHideMap} />
          )}
          renderButtonSection={() => (
            <Grid justify='flex-end' container spacing={2}>
              <Grid item xs='auto'>
                <CngButton size='medium' type='submit'>
                  Add declaration
                </CngButton>
              </Grid>
            </Grid>
          )}
        />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <ButtonSection onSetDeclaration={onSetDeclaration} />
          </Grid>
          {EPA35201Form.map((_, index) => (
            <Grid key={index} item xs={12}>
              <EPA35201FormFormProperties.Fields index={index} />
            </Grid>
          ))}
          <Grid item xs={12}>
            <ButtonSection onSetDeclaration={onSetDeclaration} />
          </Grid>
        </Grid>
      )}
    </CollapsibleSection>
  )
}

function ButtonSection(props) {
  const { onSetDeclaration } = props

  return (
    <Grid container spacing={2}>
      <Grid item xs='auto'>
        <CngButton
          color='secondary'
          size='small'
          onClick={() =>
            onSetDeclaration('nbciusinvoiceDetailsEPA35201Form', [])
          }
        >
          Clear
        </CngButton>
      </Grid>
    </Grid>
  )
}

export default EPA35201FormSection
